import { Component } from '@angular/core';

@Component({
    selector: 'aza-rws-shopping-cart-v1',
    template: '<p class="aza-rws-shopping-cart-v1-deprecated-message">This shopping cart has been deprecated. Please use the new one from the page builder.</p>',
    standalone: false
})
export class ShoppingCartV1Component {
}

